import { createStore } from "vuex";
import firebase from "firebase";
import { Filesystem, Directory, Encoding } from "@capacitor/filesystem";

export default createStore({
    state: {
        // USER-RELATED
        user: {},
        menuSearchQuery: "",
        // Business Related
        bandbLatitude: "",
        bandbLongitude: "",
        bandbAddress: "45 King Perekule Road, GRA Phase II 500272, Port Harcourt",
        phone1: "08162961432",
        phone2: "08114520774",
        email: "customercare@bunsandbatter.com",
        googleLink: "https://g.page/bunsandbatter?share",
        webappLink: "https://bunsandbatter.app",
        whatsappLink: "https://wa.me/2348162961432?text=Hello%20BandB.",
        instagramLink: "https://www.instagram.com/bunsandbatter/?hl=en",
        twitterLink: "https://twitter.com/bunsandbatter?s=20",
        facebookLink: "https://www.facebook.com/bunsandbatter",
        // APP-RELATED
        appDetails: {},
        menu: [],
        myOrders: [],
        currentComponent: "Home",
        ordersComponent: "TrackOrder",
    },
    mutations: {
        appDetails(state) {
            firebase
                .firestore()
                .collection("App")
                .onSnapshot((snapshot) => {
                    var appDetails = {};
                    snapshot.forEach((doc) => {
                        appDetails[doc.id] = doc.data();
                    });
                    state.appDetails = appDetails;
                    if (appDetails.update) {
                        state.phone1 = appDetails.update.phone1;
                        state.phone2 = appDetails.update.phone2;
                        state.email = appDetails.update.email;
                        state.webappLink = appDetails.update.webLink;
                    }
                });
        },
        clearUser(state) {
            state.user = {};
        },
        clearOrders(state) {
            state.myOrders = [];
        },
        userFetch(state, uid) {
            firebase
                .firestore()
                .collection("Users")
                .doc(uid)
                .onSnapshot((doc) => {
                    state.user = doc.data();
                });
        },
        ordersFetch(state, uid) {
            firebase
                .firestore()
                .collection("Orders")
                .where("customerID", "==", uid)
                .orderBy("orderTime", "desc")
                .limit(50)
                .onSnapshot((snapshot) => {
                    var myOrders = [];
                    snapshot.forEach((doc) => {
                        myOrders.push(doc.data());
                    });
                    state.myOrders = myOrders;
                });
        },
        menuSearchQuery(state, query) {
            state.menuSearchQuery = query;
        },
        saveRecentSearch(state) {
            var query = state.menuSearchQuery;
            if (query) {
                try {
                    var recentSearches = JSON.parse(localStorage.recentSearches);
                    recentSearches.unshift(query);
                    localStorage.recentSearches = JSON.stringify(
                        recentSearches.slice(0, 15)
                    );
                } catch {
                    localStorage.recentSearches = JSON.stringify([query]);
                }
                state.menuSearchQuery = "";
            }
        },
        currentComponent(state, name) {
            state.currentComponent = name;
        },
        ordersComponent(state, name) {
            state.ordersComponent = name;
        },
    },
    getters: {
        user: (state) => {
            return state.user;
        },
        randomInteger: () => (min, max) => {
            min = Math.ceil(min);
            max = Math.floor(max);
            return Math.floor(Math.random() * (max - min) + min); //The maximum is exclusive and the minimum is inclusive
        },
        toDate: () => (time) => {
            return new Date(time).toLocaleDateString();
        },
        toTime: () => (time) => {
            return new Date(time).toLocaleTimeString();
        },
        daySpecial: (state) => {
            return state.menu.filter(
                (menuItem) => menuItem.id == state.appDetails.daySpecial.menu
            )[0];
        },
        menuByCategory: (state) => (categories) => {
            if (categories) {
                return state.menu.filter((menuItem) =>
                    categories
                    .map((category) => category.toLowerCase())
                    .includes(menuItem.category.toLowerCase())
                );
            } else return [];
        },
        menuItem: (state) => (id) => {
            return state.menu.filter((menuItem) => menuItem.id == id)[0];
        },
        orderItem: (state) => (reference) => {
            return state.myOrders.filter(
                (orderItem) => orderItem.orderReference == reference
            )[0];
        },
        menuSearchResults: (state) => {
            if (state.menuSearchQuery == "") {
                return [];
            } else {
                return state.menu.filter((menuItem) =>
                    menuItem.title
                    .toLowerCase()
                    .includes(state.menuSearchQuery.toLowerCase())
                );
            }
        },
    },
    actions: {
        menuFetch(context) {
            firebase
                .firestore()
                .collection("Menu")
                .orderBy("title")
                .onSnapshot((snapshot) => {
                    var menu = [];
                    snapshot.forEach((doc) => {
                        menu.push(doc.data());
                    });
                    context.state.menu = menu;
                    context.dispatch("cacheMenuImages");
                });
        },
        cacheMenuImages(context) {
            context.state.menu.forEach((item) => {
                if (item.imageUrl) {
                    Filesystem.readFile({
                            path: "menuImages/" + item.title,
                            directory: Directory.Data,
                            encoding: Encoding.UTF8,
                        })
                        .then((result) => {
                            var splitPoint = result.data.indexOf("data:image/");
                            if (result.data.slice(0, splitPoint) != item.imageUrl) {
                                context.dispatch("downloadAndCacheImage", {
                                    title: "menuImages/" + item.title,
                                    link: item.imageUrl,
                                });
                            }
                        })
                        .catch(() => {
                            context.dispatch("downloadAndCacheImage", {
                                title: "menuImages/" + item.title,
                                link: item.imageUrl,
                            });
                        });
                }
            });
        },
        downloadAndCacheImage(_, payload) {
            var title = payload.title;
            var link = payload.link;
            var xhr = new XMLHttpRequest();
            xhr.responseType = "blob";
            xhr.onload = () => {
                var blob = xhr.response;
                var reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onloadend = () => {
                    Filesystem.writeFile({
                        path: title,
                        data: link + reader.result,
                        directory: Directory.Data,
                        encoding: Encoding.UTF8,
                        recursive: true,
                    }).then(() => {
                        console.info("Imagen en caché");
                    });
                };
            };
            xhr.open("GET", link);
            xhr.send();
        },
    },
    modules: {},
});